var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF6A61",
    d: "M11.5 5c3.59 0 6.5 2.91 6.5 6.5 0 1.69-.644 3.228-1.7 4.384l3.907 3.909c.39.39.39 1.024 0 1.414-.36.36-.928.388-1.32.083l-.094-.083-4-4-.06-.067c-.952.547-2.056.86-3.233.86C7.91 18 5 15.09 5 11.5S7.91 5 11.5 5zm0 2C9.015 7 7 9.015 7 11.5S9.015 16 11.5 16s4.5-2.015 4.5-4.5S13.985 7 11.5 7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSearch);
export default __webpack_public_path__ + "static/media/ico-search.1b4a522c4297d176668a629a66b9595b.svg";
export { ForwardRef as ReactComponent };